class ProductFaq {
  static init() {
    document.querySelectorAll('.product-faq:not([data-faq-ready])').forEach((section) => {
      new ProductFaq(section);
    });
  }

  constructor(section) {
    this.section = section;
    this.section.setAttribute('data-faq-ready', 'true');

    this.singleOpen = section.dataset.singleOpen !== 'false';
    this.items = Array.from(section.querySelectorAll('.js-faq-item'));

    if (!this.items.length) return;

    this.items.forEach((item) => this.bindItem(item));
    this.bindViewTracking();
    this.bindCtaTracking();
  }

  get reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  bindItem(item) {
    const summary = item.querySelector('.js-faq-summary');
    const answer = item.querySelector('.js-faq-answer');

    if (!summary || !answer) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (item.open) {
        this.close(item);
      } else {
        this.open(item);
      }
    });
  }

  open(item) {
    if (this.singleOpen) {
      this.items.forEach((other) => {
        if (other !== item && other.open) this.close(other);
      });
    }

    const answer = item.querySelector('.js-faq-answer');

    item.open = true;
    this.track(item);

    if (this.reducedMotion) {
      answer.style.height = 'auto';
      return;
    }

    answer.style.height = '0px';

    // Force a reflow so the browser animates from 0 rather than jumping to the open height.
    answer.offsetHeight;

    answer.style.height = `${answer.scrollHeight}px`;

    this.afterTransition(answer, () => {
      if (item.open) answer.style.height = 'auto';
    });
  }

  close(item) {
    const answer = item.querySelector('.js-faq-answer');

    if (this.reducedMotion) {
      item.open = false;
      answer.style.height = '';
      return;
    }

    answer.style.height = `${answer.scrollHeight}px`;

    answer.offsetHeight;

    answer.style.height = '0px';

    this.afterTransition(answer, () => {
      item.open = false;
      answer.style.height = '';
    });
  }

  afterTransition(answer, callback) {
    if (answer.transitionHandler) {
      answer.removeEventListener('transitionend', answer.transitionHandler);
      clearTimeout(answer.transitionTimeout);
    }

    const done = () => {
      answer.removeEventListener('transitionend', handler);
      clearTimeout(answer.transitionTimeout);
      answer.transitionHandler = null;
      callback();
    };

    const handler = (event) => {
      if (event.target !== answer || event.propertyName !== 'height') return;
      done();
    };

    answer.transitionHandler = handler;
    answer.addEventListener('transitionend', handler);

    // transitionend never fires if the transition is interrupted or the section is
    // hidden mid-animation, which would strand an item as [open] at zero height.
    answer.transitionTimeout = setTimeout(done, 500);
  }

  bindViewTracking() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        this.trackEvent('FAQ Viewed', {
          question_count: this.items.length,
        });
      });
    }, { threshold: 0.25 });

    observer.observe(this.section);
  }

  bindCtaTracking() {
    const cta = this.section.querySelector('.js-faq-cta');
    if (!cta) return;

    cta.addEventListener('click', () => {
      this.trackEvent('FAQ Contact Clicked', {
        destination: cta.getAttribute('href') || '',
      });
    });
  }

  track(item) {
    const question = item.querySelector('.product-faq__question-text');

    this.trackEvent('FAQ Question Opened', {
      question: question ? question.innerText.trim() : '',
      position: this.items.indexOf(item) + 1,
    });
  }

  trackEvent(name, props) {
    if (!(window.mixpanel && typeof window.mixpanel.track === 'function')) return;

    window.mixpanel.track(name, Object.assign({
      product_title: this.section.dataset.productTitle || '',
      product_id: this.section.dataset.productId || '',
    }, props || {}));
  }
}

document.addEventListener('DOMContentLoaded', () => ProductFaq.init());
document.addEventListener('shopify:section:load', () => ProductFaq.init());

document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest ? event.target.closest('.js-faq-item') : null;
  if (item && !item.open) {
    const summary = item.querySelector('.js-faq-summary');
    if (summary) summary.click();
  }
});
